import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$leaid/_error-wrapper/reports/$reporttype')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello Reporting Page</div>
}
